import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function FinalCTASection() {
  const benefits = ['Recupera tu control', 'Recupera tu confianza', 'Recupera tu vida íntima'];
  return <section className="relative w-full bg-black py-10 md:py-16 overflow-hidden" data-id="element-107">
      <div className="absolute inset-0 z-0" data-id="element-108">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] rounded-full bg-red-700/25 blur-[150px]" data-id="element-109" />
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.7) 70%, #000 100%)'
      }} data-id="element-110" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-111" />

      <div className="relative z-20 max-w-4xl mx-auto px-6" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-113">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-114">
            <div className="w-10 h-px bg-red-600" data-id="element-115" />
            <span className="text-red-500 text-xs uppercase tracking-[0.3em] font-bold" data-id="element-116">
              El momento es ahora
            </span>
            <div className="w-10 h-px bg-red-600" data-id="element-117" />
          </div>

          {/* Compact title with the "no naciste para fallar" baked in */}
          <h2 className="font-display text-4xl md:text-6xl uppercase mb-3 text-white drop-shadow-[0_0_25px_rgba(220,38,38,0.4)]" data-id="element-118">
            No naciste para fallar
          </h2>
          <p className="font-display text-3xl md:text-5xl uppercase text-transparent bg-clip-text bg-gradient-to-b from-red-400 to-red-600 drop-shadow-[0_0_20px_rgba(220,38,38,0.7)] mb-10" data-id="element-119">
            Naciste para dominar
          </p>

          {/* Benefits as horizontal pills */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-10 max-w-3xl mx-auto" data-id="element-120">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08,
            duration: 0.4
          }} className="bg-[#0a0a0a]/80 backdrop-blur-sm border border-red-900/40 rounded-full px-5 py-2.5 shadow-[0_0_15px_rgba(220,38,38,0.08)]" data-id="element-121">
                <p className="text-sm md:text-base flex items-center gap-2 text-white font-medium" data-id="element-122">
                  <span className="text-red-500" data-id="element-123">✔</span>
                  <span data-id="element-124">{benefit}</span>
                </p>
              </motion.div>)}
          </div>

          <p className="text-base md:text-lg text-gray-400 mb-10 max-w-xl mx-auto" data-id="element-125">
            Puedes seguir igual… o puedes{' '}
            <span className="text-white font-bold" data-id="element-126">romper el patrón</span> hoy.
          </p>

          {/* CTA */}
          <div className="flex flex-col items-center" data-id="element-127">
            <a href="#checkout" className="group relative inline-block w-full max-w-xl" data-id="element-128">
              <div className="absolute -inset-1 bg-red-600 rounded-xl blur-xl opacity-60 group-hover:opacity-90 transition-opacity duration-500" data-id="element-129" />
              <div className="absolute -inset-0.5 bg-gradient-to-r from-red-700 via-red-500 to-red-700 rounded-xl blur opacity-80 group-hover:opacity-100 transition duration-500" data-id="element-130" />

              <motion.button whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="relative w-full flex items-center justify-center gap-3 bg-gradient-to-b from-red-600 to-red-800 text-white font-display text-xl md:text-3xl uppercase tracking-wider py-6 md:py-7 rounded-xl border border-red-400/40 shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_20px_50px_-15px_rgba(220,38,38,0.7)] transition-all duration-300" data-id="element-131">
                <span className="drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]" data-id="element-132">
                  👉 Quiero empezar ahora
                </span>
                <ArrowRightIcon className="w-6 h-6 md:w-7 md:h-7 group-hover:translate-x-2 transition-transform duration-300" data-id="element-133" />
                <span className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/15 to-transparent rounded-t-xl pointer-events-none" data-id="element-134" />
              </motion.button>
            </a>

            <p className="mt-5 text-xs md:text-sm text-gray-500 uppercase tracking-widest flex items-center gap-3" data-id="element-135">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-136" />
              Acceso inmediato · 100% seguro y discreto
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}